import auth from '../authentication';
import Vue from '../main';

export default {
    getChallenge(context, data, callback) {
        Vue.http.post(Vue.apiUrl + '/challenge/get-all', data)
            .then(response => {
                context.error = false;
                context.challenges = response.data.data;
                context.total = response.data.total;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.message = response.data ? response.data.message : 'Network error';
                context.total = 0;
                callback(context);
            })
    },
    getChallengeSelect(context, callback) {
        Vue.http.post(Vue.apiUrl + '/challenge/get-select')
            .then(response => {
                context.error = false;
                context.challenges = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.message = response.data ? response.data.message : 'Network error';
                callback(context);
            })
    },
    createChallenge(context, data, callback) {
        Vue.http.post(Vue.apiUrl + '/challenge/add-new', data)
            .then(response => {
                context.error = false;
                context.success = true;
                context.challenge = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                context.message = response.data ? response.data.message : 'Network error';
                callback(context);
            })
    },
    getChallengeDetail(context, id, callback) {
        Vue.http.post(Vue.apiUrl + '/challenge/get-detail/' + id)
            .then(response => {
                context.error = false;
                context.challenge = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.message = response.data ? response.data.message : 'Network error';
                callback(context);
            })
    },
    updateChallenge(context, id, data, callback) {
        Vue.http.post(Vue.apiUrl + '/challenge/update-detail/' + id, data)
            .then(response => {
                context.error = false;
                context.success = true;
                context.challenge = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                context.message = response.data ? response.data.message : 'Network error';
                callback(context);
            })
    },
    removeChallenge(context, id, callback) {
        Vue.http.post(Vue.apiUrl + '/challenge/remove/' + id, {})
            .then(response => {
                context.error = false;
                context.success = true;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                callback(context);
            })
    }
};
